export default __webpack_public_path__ + "static/media/doctors-box4.ea780ce7.svg";